exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ingredients[data-v-1495ed5a]{background-color:#3c3c3c;margin:10px;border-radius:5px;padding-top:1px;padding-bottom:10px}.ingredients h4[data-v-1495ed5a]{text-align:center;font-size:16px;margin-top:5px;margin-bottom:0}.ingredients .ingredientObjects[data-v-1495ed5a]{display:flex;flex-wrap:wrap;flex-direction:row;justify-content:center;margin-left:10px}.ingredients .ingredientObject[data-v-1495ed5a]{display:flex;align-items:center;margin:5px;z-index:1;position:relative;display:block;background-color:#555;width:80px;height:80px;border:2px solid #333;border-radius:5px}.ingredients .ingredientObject[data-v-1495ed5a]:hover{border-color:#aaa;background-color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1495ed5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RecipeIngredients.vue
// module id = 90
// module chunks = 0